/**
 * Add an address to the Common Ninja newsletter (the SendRaven audience).
 * commonninja-users serves this; the proxy routes /api/user to it. Throws
 * with a message fit to show the visitor.
 */
export async function subscribeToNewsletter(email: string) {
  const res = await fetch('/api/user/newsletter/subscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  let result: { success?: boolean; message?: string } = {};
  try {
    result = await res.json();
  } catch (e) {}

  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Oops, something went wrong, please try again.');
  }
}
